import React from "react";

import PriceFormatter from "@components/Formatters/PriceFormatter";
import FormattedMessage from "@components/UI/FormattedMessage";
import Modal from "@components/UI/Modal";

export default function BookingPriceConfirmation({
  show,
  originalPrice,
  newPrice,
  currency,
  onConfirm,
}: {
  show: boolean;
  originalPrice: number;
  newPrice: number;
  currency: string;
  onConfirm: () => void;
}) {
  return (
    <Modal isActive={show} isCloseButtonHidden>
      <div className="bookingPriceConfirmation">
        <h3 className="heading">
          <FormattedMessage id="BookingPriceConfirmation.heading" />
        </h3>
        <p>
          <FormattedMessage id="BookingPriceConfirmation.description" />
        </p>
        <div className="prices-actions">
          <div className="price-group">
            <span className="price strikethrough">
              <PriceFormatter price={originalPrice} customCurrency={currency} />
            </span>
            <span className="price-label">
              <FormattedMessage id="BookingPriceConfirmation.originalPrice" />
            </span>
          </div>
          <div className="price-group">
            <span className="price">
              <PriceFormatter price={newPrice} customCurrency={currency} />
            </span>
            <span className="price-label">
              <FormattedMessage id="BookingPriceConfirmation.newPrice" />
            </span>
          </div>

          <button
            type="button"
            className="search-btn"
            onClick={() => window.history.back()}
          >
            <FormattedMessage id="BookingPriceConfirmation.newSearch" />
          </button>
          <button
            type="button"
            className="confirm-btn"
            id="confirm-new-price-btn"
            onClick={onConfirm}
          >
            <FormattedMessage id="BookingPriceConfirmation.agree" />
          </button>
        </div>
      </div>
    </Modal>
  );
}
